/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Bill_Back_CurrentInputs */



/**
* | output |
* | --- |
* | "Show the current month" |
*
* @param {Partner_Org_Bill_Back_CurrentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_bill_back_current = /** @type {((inputs?: Partner_Org_Bill_Back_CurrentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Bill_Back_CurrentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuellen Monat anzeigen")
	return /** @type {LocalizedString} */ ("Show the current month")
});